<template>
  <DashboardCard ref="dashboardCard" @controlsOpen="animatePanel()">
    <img src="@/assets/images/chart.svg" alt="Gráfico de linhas" slot="icon">
    <div slot="title">
      Relatório consolidado
      <br>
      <small v-if="advertiserDisplayName">{{ advertiserDisplayName }}</small>
    </div>

    <div slot="controls" v-if="chartData">
      <h4 class="ml-1 d-flex align-items-center justify-content-left">
        {{ this.controlsTitle }}
      </h4>
      <ReportForm
        ref="panelForm"
        :initialOptions="options"
        @success="setReport"
        @change="opt => options = opt"
        @error="err => error = err.message"
        @reset="error = null;"
        :isCompact="true" />

      <router-link :to="{name:'relatorios', params:{initialReportOptions: this.options}}"
                   class="d-flex align-items-center justify-content-center">
        <a> {{ this.goToReportViewText }} </a>
      </router-link>
      <div v-if="error" class="d-flex align-items-center justify-content-center">
        <img src="@/assets/failure.svg" alt="Erro" class="mr-2">
        <span>{{ error }}</span>
      </div>
    </div>

    <div v-if="chartData">
      <LineChart v-model="chartData"
                 :initialHiddenCaptions="lineChartInitialHiddenCaptions"
                 @toggle="saveHiddenCaptions"/>
    </div>

    <div v-if="!report">
      <b-row alignH="around">
        <b-col cols="12" lg="7">
          <ReportForm ref="firstEntryForm"
            :initialOptions="options"
            @success="setReport"
            @change="opt => options = opt"
            @error="err => error = err.message"
            @reset="error = null;"
            :isCompact="true" />
          <div v-if="error" class="d-flex align-items-center justify-content-center">
            <img src="@/assets/failure.svg" alt="Erro" class="mr-2">
            <span>{{ error }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
  </DashboardCard>
</template>

<script>
import { mapGetters } from 'vuex';
import ReportForm from './ReportForm';
import LineChart from './LineChart';
import DashboardCard from './DashboardCard';

const secondTierFieldKey = 'secondTierWinValue';
export default {
  name: 'ConsolidatedGraphCard',
  components: {
    ReportForm,
    LineChart,
    DashboardCard,
  },
  data() {
    return {
      controlsTitle: 'Alterar relatório consolidado',
      goToReportViewText: 'Ir para relatório completo',
      report: null,
      options: null,
      localStorageReportOptions: '_report_options_',
      localStorageHiddenCaptions: '_report_hidden_captions_',
      lineChartInitialHiddenCaptions: [],
      advertiserDisplayName: '',
      error: null,
    };
  },
  async created() {
    if (localStorage.getItem(this.localStorageHiddenCaptions)) {
      this.lineChartInitialHiddenCaptions = JSON.parse(
        localStorage.getItem(this.localStorageHiddenCaptions),
      );
    }
    if (localStorage.getItem(this.localStorageReportOptions)) {
      this.options = JSON.parse(localStorage.getItem(this.localStorageReportOptions));
    }
  },
  mounted() {
    if (this.options && this.options.products.length) {
      this.$refs.firstEntryForm.submitForm();
    }
  },
  computed: {
    ...mapGetters(['affiliateAdvertisers']),
    chartData() {
      if (this.report) return this.generateChartData();
      return null;
    },
    selectedAdvertiserName() {
      if (!this.options) return null;

      const advertiser = this.affiliateAdvertisers
        .find(adv => adv.idtCommissionEventSourceGroup === this.options.products[0]);

      return advertiser ? advertiser.desCommissionEventSourceGroup : null;
    },
  },
  methods: {
    generateChartData() {
      const chartData = {
        categories: [],
        series: [],
        title: this.selectedAdvertiserName,
      };

      chartData.series = this.report.reportResult.fields
        .filter(field => field.key !== 'datEvent')
        .map(field => ({
          name: field.label,
          key: field.key,
          data: [],
        }));

      if (this.secondTierColumnMustBeRemoved(this.report.reportResult)) {
        chartData.series = chartData.series.filter(s => s.key !== secondTierFieldKey);
      }

      this.report.reportResult.lines.forEach((reportLine) => {
        chartData.categories.push(reportLine.datEvent);
        chartData.series.forEach((serie) => {
          serie.data.push(reportLine[serie.key]);
        });
      });

      return chartData;
    },
    setReport(report) {
      if (!this.report) this.track('Alterou as configurações do relatório');
      else this.track('Gerou relatório rápido');

      this.advertiserDisplayName = this.selectedAdvertiserName;
      this.error = null;
      this.report = report;
      localStorage.setItem(this.localStorageReportOptions, JSON.stringify(this.options));
      this.$refs.dashboardCard.closeControls();
    },
    saveHiddenCaptions(hiddenCaptions) {
      localStorage.setItem(this.localStorageHiddenCaptions, JSON.stringify(hiddenCaptions));
    },
    secondTierColumnMustBeRemoved(result) {
      return result.fields.some(f => f.key === secondTierFieldKey)
        && result.totals.filter(t => t.column === secondTierFieldKey)[0].value === 0;
    },
    animatePanel() {
      if (this.panelForm) this.panelForm.animateScroll();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .card__controls__panel {
    width: 550px;
  }
}
</style>
